// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tenderId: __t.u64().primaryKey().name("tender_id"),
  postKey: __t.string().name("post_key"),
  sigKey: __t.string().name("sig_key"),
  systemId: __t.string().name("system_id"),
  kind: __t.string(),
  rewardSov: __t.i64().name("reward_sov"),
  state: __t.string(),
  acceptedBy: __t.identity().name("accepted_by"),
  acceptedAt: __t.timestamp().name("accepted_at"),
  deadline: __t.timestamp(),
  outcome: __t.string(),
  paidSov: __t.i64().name("paid_sov"),
  refundSov: __t.i64().name("refund_sov"),
  receipt: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
